import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import resumeData from '../../utils/resume-data';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        background: 'black',
        width: '100%',
        height: '90%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    aboutdiv: {
        width: '96%',
        background: 'black',
        color: 'whitesmoke',
        textAlign: 'center',
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '@media (min-width:1200px)': {
            width: '60%',
            maxWidth: 900,
        },
    },
    heading: {
        color: 'whitesmoke',
        borderBottomStyle: 'solid',
        fontSize: '2.5rem',
        '@media (max-width:600px)': {
            fontSize: '2rem',
        },
    },
    aboutbody: {
        color: "orange",
    },
    intro: {
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, 
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        color: '#ccc',
        fontSize: '1.1rem',
        marginTop: 10,
        lineHeight: 2,
        fontWeight: 300,
        '@media (min-width:600px)': {
            fontSize: '1.3rem',
            maxWidth: '80%',
        },
    },
    container: {

    },
    btn: {
        color: 'orange',
        paddingLeft: 0,
        '@media (min-width:600px)': {
            fontSize: '1rem',
            paddingBottom: '4rem',
        },
        '@media (min-width:1024px)': {
            fontSize: '1.2rem',
        },
    },
}));


const About = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.aboutdiv}>
                <Typography className={classes.heading} gutterBottom>
                    {resumeData.aboutme}
                </Typography>
                <Typography
                    variant="h6"
                    className={classes.aboutbody}
                    gutterBottom>
                    {resumeData.intro.line1}
                </Typography>
                {/* <div className={classes.container}> */}
                <Typography className={classes.intro} gutterBottom>
                    {resumeData.intro.line2}
                </Typography>
                <Typography className={classes.intro} gutterBottom>
                    {resumeData.intro.line3}
                </Typography>
                <Typography className={classes.intro} gutterBottom>
                    {resumeData.intro.line4}
                </Typography>
                <Typography className={classes.intro} gutterBottom>
                    {resumeData.intro.line5}
                </Typography>
                {/* </div> */}
                <Button className={classes.btn} variant="outlined" href="/projects">
                    View Projects <DoubleArrowIcon />
                </Button>
            </div>
        </div>
    );
}

export default About
